import { ImageOff } from "lucide-react";
import { PHASE_MAP } from "@/lib/phases";

export const SitePlaceholder = ({ phase, compact = false, className = "" }) => {
  const ph = PHASE_MAP[phase] || PHASE_MAP.pyramids;
  return (
    <div
      className={`flex flex-col items-center justify-center bg-secondary text-center ${className}`}
      style={{
        backgroundImage: `repeating-linear-gradient(45deg, ${ph.color}14 0, ${ph.color}14 1px, transparent 1px, transparent 11px)`,
      }}
      data-testid="site-placeholder"
    >
      <ImageOff style={{ color: ph.color, opacity: 0.5 }} size={compact ? 16 : 26} />
      {!compact && (
        <span className="mt-2 px-2 font-mono text-[9px] uppercase tracking-widest text-muted-foreground">
          No photograph on record
        </span>
      )}
    </div>
  );
};
